import { scroller } from 'react-scroll'

import { paths } from '@mc/paths'
import { useTranslation } from '@mc/i18n'

import CTA from 'components/CTA'

import { trackCTAClicked } from './events'

interface EnterpriseCTAProps {
  className?: string
  pageSource: string
  location: string
  buttonText?: string
  href?: string
  scrollToForm?: boolean
  onClick?: () => void
  [x: string]: unknown
}

const EnterpriseCTA = ({
  className,
  pageSource,
  location,
  buttonText,
  href,
  scrollToForm = false,
  onClick,
  ...props
}: EnterpriseCTAProps) => {
  const { t } = useTranslation('@mc/next')

  const CTAText = t('skillCategoryPage.cta')

  const onCTAClicked = () => {
    if (scrollToForm) {
      scroller.scrollTo('contact-form', {
        smooth: true,
        offset: -100,
      })
    }
    trackCTAClicked({
      action: CTAText,
      page_source: pageSource,
      location,
    })
    if (onClick) {
      onClick()
    }
  }

  return (
    <CTA
      className={className}
      href={href || paths.enterpriseHomepage}
      trackPurchaseClick={false}
      onClick={onCTAClicked}
      {...props}
    >
      {CTAText}
    </CTA>
  )
}

export default EnterpriseCTA
